import styled from 'styled-components';

export const TrendingProducts = styled.div`
	& > p {
		color: #000;
		font-family: var(--fontFamily);
		font-size: 14px;
		font-style: normal;
		font-weight: 400;
		line-height: normal;
	}
	& > .cards-container {
		margin-top: 16px;
		margin-bottom: 27px;

		// gap: 10px;

		& .ff-product-carousel-swap {
			& > .carousel-root {
				// max-width: 409px;
				& > .carousel.carousel-slider {
					& > .control-dots {
						display: none;
					}
					& > .slider-wrapper {
						& > ul {
							padding: 0 !important;
							padding-right: ${(props) =>
								props.screenSize < 375 ? '' : '65px'};
							// gap: 10px;
						}
					}
					& > .carouselButtons-swap-trending {
						z-index: 10;
						position: absolute;
						border: none;
						background: none;
					}
				}
			}
			&.large {
				display: flex;
				gap: 10px;
				& > .carousel-root {
					// max-width: unset;
				}
			}
		}
		& .ff-card-fractal {
			max-width: 230px;
			min-width: 230px;
			border-radius: 9.672px;
			overflow: hidden;
			background: white;
			&.tablet {
				min-width: 200px;
			}
			// &.mobile {
			// 	max-width: 200px;
			// 	min-width: 200px;
			// }

			& img {
				max-width: 230px;
				min-height: 134px;
				max-height: 134px;
				width: 100%;
				object-fit: cover;
			}
			& > .card-img.custom {
				background: #008c71;
				display: flex;
				justify-content: center;
				& > img {
					width: unset;
				}
			}

			& > .desc-container {
				padding: 14px 20px;
				& > img {
					// height: 14px;
				}
				& > div {
					overflow: hidden;
					color: #4e4e4e;
					font-feature-settings: 'liga' off, 'clig' off;
					text-overflow: ellipsis;
					font-family: Poppins;
					font-size: 12px;
					font-style: normal;
					font-weight: 400;
					line-height: 16px;
					margin-top: 12px;
				}
				& > .ff-buttons-fractal {
					& .custom-button {
						.MuiButton-root {
							&:not(.Mui-disabled):hover {
								&:after {
									border-radius: 20px;
								}
							}
						}
						& > button {
							width: fit-content;
							padding: 8px 12px;
							border-radius: 15px;
							font-family: var(--fontFamily);
							font-size: 14px;
							font-style: normal;
							font-weight: 400;
							line-height: 11.951px;
							cursor: pointer;
							height: 37px;
							background: #0174e7;
							&.experience {
								background-color: white !important;
								border: 0.498px solid #0174e7;
								& > div {
									color: #000 !important;
								}
							}
							&.expand {
								width: 100%;
							}

							& > .custom-button-body {
								color: #fff !important;
								font-size: 12px;
								font-style: normal;
								font-weight: 400;
								line-height: 11.951px;
								font-family: var(--fontFamily);
								& .MuiButton-endIcon {
									position: relative;
									top: 1px;
								}
							}
						}
					}
				}
			}
		}
	}
`;
